import {RouteConfig} from 'vue-router';
import TerminalView from '@/views/terminal/index.vue';

export const TerminalRoutes: Array<RouteConfig | any> = [
  {path: '/terminal/home', name: 'terminalHome', component: TerminalView}
];
